import script from "./InventoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__